import {AppConstants} from "../../app-constants";

export class AccreditationEvidenceFile {
  upVoteCount: number;
  downVoteCount: number;
  evidenceGuid: string;
  evidenceID: number;
  filename: string;
  fileURL: string;
  file: any;
  fileSizeText: string;
  lastModified: string;
  description: string;
  schoolCommentCount: number;
  isArchived: boolean;
  previewInfo: evidencePreviewInfo;
  isGettingUploaded: boolean;
  errorAtPreviewGeneration: boolean;
  errorMessageAtPreviewGeneration: string;
  uploadProgress: number;
  fileExtension: string;

  isWeaveReport: boolean;

  constructor(
    filename: string = String(),
    downVoteCount: number = 0,
    upVoteCount: number = 0,
    fileURL: string = String(),
    description: string = String(),
    schoolCommentCount: number = 0,
    evaluatorCommentCount: number = 0,
    isArchived: boolean = false,
    previewInfo: evidencePreviewInfo = null,
    evidenceID: number = 0,
    evidenceGuid: string = String(),
    isWeaveReport: boolean = false
  ) {
    this.evidenceID = evidenceID;
    this.evidenceGuid = evidenceGuid;
    this.downVoteCount = downVoteCount;
    this.upVoteCount = upVoteCount;
    this.filename = filename;
    this.fileURL = fileURL;
    this.description = description;
    this.schoolCommentCount = schoolCommentCount;
    this.isArchived = isArchived;
    this.previewInfo = previewInfo;
    this.isGettingUploaded = false;
    this.uploadProgress = 100;
    this.errorAtPreviewGeneration = false;
    this.errorMessageAtPreviewGeneration = '';
    this.isWeaveReport = isWeaveReport;
    if(fileURL){
      this.fileExtension = this.getMimeByExt(fileURL);
    }
    else if(filename){
      this.fileExtension = this.getMimeByExt(filename);
    }
  }


  getMimeByExt(fileURL) {
    if(fileURL){
      let ext: string = fileURL.split('.').pop().toLowerCase();
      if (AppConstants.extToMimes.hasOwnProperty(ext)) {
        return AppConstants.extToMimes[ext];
      }
    }
    return 'other';
  };
}

export interface evidencePreviewInfo{
  previewPageCount: number;
  images: string[]
}
